'use client';
import { SliderProps } from '@mui/material';
import React, { FC } from 'react';
import { Control, useController } from 'react-hook-form';
import WrappedSlider from '..';
import { removeCommas } from '@/utils';

interface ISliderControlled {
  name: string;
  control: Control;
  sliderLabel?: boolean;
}
const WrappedSliderFormControlled: FC<SliderProps & ISliderControlled> = ({
  name,
  control,
  ...props
}) => {
  const { field } = useController({ name, control });
  return (
    <WrappedSlider
      {...props}
      value={removeCommas(field.value)}
      onChange={(_, value) => {
        field.onChange(value as number);
      }}
    />
  );
};

export default WrappedSliderFormControlled;
